import { render } from "./InstallApp.vue?vue&type=template&id=824ebe0c&scoped=true"
import script from "./InstallApp.vue?vue&type=script&lang=js"
export * from "./InstallApp.vue?vue&type=script&lang=js"

import "./InstallApp.vue?vue&type=style&index=0&id=824ebe0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-824ebe0c"]])

export default __exports__